import {UntilDestroy} from "@ngneat/until-destroy";
import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {DynamicFormReadyEvent} from "@mydocma/dynamic-form";
import {TranslateService} from "@ngx-translate/core";

@UntilDestroy()
@Injectable()
export class LayoutEditFiltersService {

  private filtersFormServices: DynamicFormReadyEvent;
  private attachedSubject = new BehaviorSubject<boolean>(false);

  private selectedFiltersCountSubject = new BehaviorSubject<number>(0);
  selectedFiltersCount$ = this.selectedFiltersCountSubject.asObservable();

  constructor(private readonly transalteService: TranslateService) {
  }

  public async attachToForm(event: DynamicFormReadyEvent) {
    this.filtersFormServices = event;
    this.attachedSubject.next(true);
  }

  public validate(): boolean {
    return true;
  }
   
  public updateSelectedFiltersCount(count: number) {
    this.selectedFiltersCountSubject.next(count);
  }
}
